import { createAsyncThunk } from '@reduxjs/toolkit';

import { setUpdateInvoice } from '../services/setUpdateInvoice';


export const patchUpdateInvoice = createAsyncThunk(
  'invoices/patchUpdateInvoice',
  async ({ invoiceId, updateData, projectId: explicitProjectId }, { getState, dispatch }) => {
    // Prefer an explicit projectId from the caller (the invoice's own project);
    // fall back to the store's selectedProjectId for existing callers.
    const projectId = explicitProjectId || getState().projects.selectedProjectId;

    const response = await setUpdateInvoice(
      invoiceId,
      projectId,
      updateData
    );
    return response
  }
);
